import { render } from "./depoimento.vue?vue&type=template&id=00b542ca&scoped=true&bindings={\"title\":\"props\",\"text\":\"props\",\"cardTitle\":\"setup\",\"cardText\":\"setup\"}"
import script from "./depoimento.vue?vue&type=script&lang=js"
export * from "./depoimento.vue?vue&type=script&lang=js"

import "./depoimento.vue?vue&type=style&index=0&id=00b542ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-00b542ca"

export default script